module.exports = __webpack_public_path__ + "img/nav_4_active.179384e1.gif";